import dynamic from "next/dynamic";
import SimpoCustomerSuccessConfig from "./simpo-customer-success-config";
import SimpoCustomerSuccessAdvancedConfig from "./simpo-customer-success-advanced-config";
const SimpoCustomerSuccessComponent = dynamic(()=>import("./simpo-customer-success-component"));
export default {
    SimpoCustomerSuccessComponent,
    SimpoCustomerSuccessConfig,
    SimpoCustomerSuccessAdvancedConfig
};
